(function pollForNostoCarousel() {
  const carouselClass = ".nosto_carousel_redesign";
  const styleTagId = "customCarouselStyles";

  if (document.querySelector(".nosto_carousel_redesign.slick-initialized")) {
    // Ensure the style tag exists or create it
    let $styleTag = $(`#${styleTagId}`);
    if (!$styleTag.length) {
      $styleTag = $("<style>", {
        id: styleTagId,
        type: "text/css",
      });
      $("head").append($styleTag);
    }

    function UpdateSlickTransition($carousel, parentId) {
      if (!$carousel.length) {
        console.error(`Carousel not found with selector ${carouselClass}`);
        return;
      }

      function getItemWidthWithRetry(retryCount = 0) {
        const itemWidth = $(`#${parentId} .slick-slide`).outerWidth();

        // Continue with the rest of the function when we have a valid width
        const totalItems = $carousel.slick("getSlick").slideCount;
        const transationItem =
          totalItems - $carousel.slick("getSlick").options.slidesToShow;
        const transationWidth = transationItem * itemWidth + itemWidth / 2;
        const transationWidthForHome =
          transationItem * itemWidth +
          parseInt($(`#${parentId} .title-bar`).css("padding-right"), 10);

        const transformValue = `translate3d(-${
          $("body").hasClass("templateIndex")
            ? transationWidthForHome
            : transationWidth
        }px, 0px, 0px)`;

        const slickTrackWidth = itemWidth * totalItems;

        // Update CSS rules for the specific carousel
        const cssRule = `
          @media (min-width: 769px) {
            #${parentId} .nosto_carousel.at-end .slick-track {
              transform: ${transformValue} !important;
              transition: 500ms;
            }
            
            
            #${parentId} .nosto_carousel:not(.at-end) .slick-track {
              width: calc(${slickTrackWidth}px + ${
          $("body").hasClass("templateIndex") && window.innerWidth > 1400
            ? "((100vw - 1340px) / 2)"
            : "10%"
        }) !important;
            transition: 500ms;
            }
          }
        `;

        // Append the rule to the style tag
        const existingStyles = $styleTag.html();
        const updatedStyles =
          existingStyles.replace(
            new RegExp(
              `#${parentId} .nosto_carousel.at-end .slick-track {[^}]*}`,
              "g"
            ),
            ""
          ) + cssRule;
        $styleTag.html(updatedStyles);
      }

      // Start the retry process
      getItemWidthWithRetry();
    }

    // Apply logic to each initialized carousel
    $(carouselClass).each(function () {
      const $carousel = $(this);
      const parentId = $carousel.closest(".nosto_element").attr("id");

      // Initial update
      UpdateSlickTransition($carousel, parentId);

      // Handle resize events for each carousel
      let resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          UpdateSlickTransition($carousel, parentId);
        }, 200); // Adjust delay if needed
      });

      // Handle afterChange to detect the last slide
      $(`#${parentId}`).on(
        "afterChange",
        function (event, slick, currentSlide, index) {
          if (currentSlide >= slick.slideCount - slick.options.slidesToShow) {
            $(`#${parentId} .nosto_carousel`).addClass("at-end");
          } else {
            $(`#${parentId} .nosto_carousel`).removeClass("at-end");
          }

          // if (isLeftArrowDisable.hasClass("slick-disabled")) {
          //   $(`#${parentId} .nosto_carousel`)
          //     .removeClass("at-start")
          //     .addClass("at-end");
          // } else if (
          //   !isLeftArrowDisable.hasClass("slick-disabled") &&
          //   $(`#${parentId} .nosto_carousel`).hasClass("at-end")
          // ) {
          //   $(`#${parentId} .nosto_carousel`)
          //     .addClass("at-start")
          //     .removeClass("at-end");
          // }
        }
      );
    });
  } else {
    setTimeout(pollForNostoCarousel, 25);
  }
})();
